const localStorageKey = 'storeeel_cta_click';

export const ctaClickRepository = {
  set(mediaId, campaignId) {
    const expireAt = Date.now() + 24 * 60 * 60 * 1000; // 24時間後
    const key = `${mediaId}__${campaignId}`;

    const existing = JSON.parse(localStorage.getItem(localStorageKey) || "{}");

    existing[key] = {
      TTL: expireAt,
      mediaId,
      campaignId
    };

    localStorage.setItem(localStorageKey, JSON.stringify(existing));
  },

  getAllValid() {
    const now = Date.now();
    const result = {};

    try {
      const data = JSON.parse(localStorage.getItem(localStorageKey) || "{}");

      Object.entries(data).forEach(([key, info]) => {
        if (info?.TTL && info.TTL > now) {
          result[key] = info;
        }
      });

      return result;
    } catch {
      return {};
    }
  },

  removeExpired() {
    const now = Date.now();
    const data = JSON.parse(localStorage.getItem(localStorageKey) || "{}");
    let updated = false;

    Object.entries(data).forEach(([key, info]) => {
      if (info.TTL <= now) {
        delete data[key];
        updated = true;
      }
    });

    if (updated) {
      localStorage.setItem(localStorageKey, JSON.stringify(data));
    }
  },
  removeByCampaignId(campaignId) {
    const data = JSON.parse(localStorage.getItem(localStorageKey) || "{}");
    const updatedKeys = Object.keys(data).filter(key => key.endsWith(`__${campaignId}`));

    if (updatedKeys.length > 0) {
      updatedKeys.forEach(key => delete data[key]);
      localStorage.setItem(localStorageKey, JSON.stringify(data));
    }
  }
};
